"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopRightsHoldersSection = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const Pagination_1 = __importDefault(require("@Components/Pagination"));
const RightsholderAccountCard_1 = __importDefault(require("@Components/Cards/AccountCard/RightsholderAccountCard"));
const TopRightsHoldersSection = (props) => {
    const { name, rightsHolders, preloader, limitItems, openPopup, paginationPages, onChangePagination, viewDetails } = props;
    return (react_1.default.createElement("div", { className: 'top-rightsholders-section' },
        react_1.default.createElement("div", { className: 'line-name' },
            react_1.default.createElement("p", { className: 'bold blue-text' },
                name,
                " (",
                rightsHolders ? rightsHolders.count : 0,
                ")")),
        react_1.default.createElement("div", { className: 'rightsholders-block' },
            react_1.default.createElement("div", { className: 'grid-container' },
                preloader ? (react_1.default.createElement(PointPreloader_1.default, null)) : (rightsHolders === null || rightsHolders === void 0 ? void 0 : rightsHolders.rightsholders.map((item, index) => (react_1.default.createElement(RightsholderAccountCard_1.default, { key: item.id ? item.id : index, rightsholderData: item, openPopup: () => openPopup(true, item.id), viewDetails: viewDetails })))),
                rightsHolders && !rightsHolders.count && react_1.default.createElement("p", { className: 'small no-results' }, "No Members")),
            rightsHolders && rightsHolders.count > limitItems && (react_1.default.createElement(Pagination_1.default, { limit: limitItems, paginationPages: paginationPages, onChange: onChangePagination })))));
};
exports.TopRightsHoldersSection = TopRightsHoldersSection;
